/**
 * Mock Data Service
 * Provides clean test data for development
 * All emails use @example.com domain
 */

// Clean Mock Users (all @example.com) - No hardcoded IDs
const mockUsers = {
  'e488a4d8-20f1-70f9-1468-71e27c8aef39': {
    userId: 'e488a4d8-20f1-70f9-1468-71e27c8aef39',
    email: 'frankly.dan@gmail.com',
    firstName: 'Danny',
    lastName: 'Frank',
    role: 'admin',
    profileStatus: 'complete',
    profileCompleted: true,
    certifyingBody: 'RID',
    membershipType: 'CI/CT',
    memberNumber: 'RID12345',
    currentCycleStart: '2025-06-28',
    currentCycleEnd: '2028-12-30',
    createdAt: '2024-01-01T00:00:00.000Z',
    updatedAt: '2024-01-01T00:00:00.000Z'
  }
};

// Clean Mock CEUs - Only for admin user
const mockCEUs = {
  'e488a4d8-20f1-70f9-1468-71e27c8aef39': [
    {
      ceuId: 'mock-ceu-001', // Static ID for consistent mock data
      userId: 'e488a4d8-20f1-70f9-1468-71e27c8aef39',
      title: 'Sample Workshop: ASL Linguistics',
      date: '2025-07-15',
      ceuHours: 2.0,
      category: 'Professional Studies',
      subCategory: ['Linguistics'],
      instructor: 'Dr. Sample Instructor',
      organization: 'Example ASL Institute',
      description: 'Sample workshop for testing purposes',
      certificateUrl: null,
      ridReceived: true,
      beiReceived: false,
      createdAt: '2025-07-15T00:00:00.000Z',
      updatedAt: '2025-07-15T00:00:00.000Z'
    }
  ]
};

/**
 * Get mock user by ID
 */
export function getMockUser(userId) {
  return mockUsers[userId] || null;
}

/**
 * Get all mock users
 */
export function getAllMockUsers() {
  return Object.values(mockUsers);
}

/**
 * Get mock CEUs for user
 */
export function getMockCEUs(userId) {
  return mockCEUs[userId] || [];
}

/**
 * Get all mock CEUs
 */
export function getAllMockCEUs() {
  const allCEUs = [];
  Object.values(mockCEUs).forEach(userCEUs => {
    allCEUs.push(...userCEUs);
  });
  return allCEUs;
}

/**
 * Check if user exists in mock data
 */
export function mockUserExists(userId) {
  return mockUsers.hasOwnProperty(userId);
}

/**
 * Get mock user by email
 */
export function getMockUserByEmail(email) {
  return Object.values(mockUsers).find(user => user.email === email) || null;
}

const mockDataService = {
  getMockUser,
  getAllMockUsers,
  getAllUsers: () => ({ success: true, users: getAllMockUsers() }),
  getMockCEUs,
  getAllMockCEUs,
  getAllCEUs: async () => {
    // Return consistent format for admin analytics
    return { success: true, data: getAllMockCEUs() };
  },
  mockUserExists,
  getMockUserByEmail,
  getUser: (userId) => {
    const user = getMockUser(userId);
    return user ? { success: true, data: user } : { success: false, error: 'User not found' };
  },
  getCEUs: (userId) => {
    const ceus = getMockCEUs(userId);
    return { success: true, data: ceus };
  }
};

export default mockDataService;
